export function scrollToAnchor(anchorName) {
  const el = document.getElementById(anchorName) as HTMLElement
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

/**
 * Déclenche le téléchargement navigateur d'un fichier à partir d'un Blob.
 * Encapsule le hack DOM : le lien doit être attaché au document avant `click()`
 * (Firefox/Safari n'ouvrent pas le téléchargement sur un `<a>` détaché), puis nettoyé.
 */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

/** Télécharge un objet sérialisé en JSON indenté (2 espaces). */
export function downloadJson(filename: string, data: unknown): void {
  downloadBlob(filename, new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }))
}
